/**
 * Id scheme tying a browse dialog's search field to its results.
 *
 * These dialogs keep DOM focus in the search field and move a purely visual
 * highlight through the results, so the only way a screen reader learns which
 * item is current is `aria-activedescendant` on the field pointing at an
 * option's id. Both ends have to agree on the id, and they live in different
 * components — hence one place to derive it.
 *
 * Keyed by index rather than by item id: the highlight is an index, and paged
 * lists hold holes where items have not arrived yet.
 */
export const browseListboxId = (dialog: string) => `${dialog}-listbox`;

export const browseOptionId = (dialog: string, index: number) =>
  `${dialog}-option-${index}`;
